<h1 translate>DISCOUNTS</h1>
<div class="text-right">
    <button class="btn btn-primary mr-2" type="button" (click)="import()">
        <span translate>IMPORT</span>(XLSX)
    </button>
    <button class="btn btn-primary " type="button" (click)="export()">
        <span translate>EXPORT</span>(XLSX)
    </button>
</div>
<lib-filter-list [configService]="colmecDiscountListConfigService"></lib-filter-list>

